export const COLOR_SCHEMES = {
  DEFAULT: "Predeterminado",
  BLUE: "Azul",
  GREEN: "Verde",
  PURPLE: "Morado",
  ORANGE: "Naranja",
} as const;

export type ColorSchemeVariant = (typeof COLOR_SCHEMES)[keyof typeof COLOR_SCHEMES];

export const COLOR_SCHEME_CLASS: Record<ColorSchemeVariant, string | null> = {
  [COLOR_SCHEMES.DEFAULT]: null,
  [COLOR_SCHEMES.BLUE]: "color-scheme-blue",
  [COLOR_SCHEMES.GREEN]: "color-scheme-green",
  [COLOR_SCHEMES.PURPLE]: "color-scheme-purple",
  [COLOR_SCHEMES.ORANGE]: "color-scheme-orange",
};

export const THEME_MODE_OPTIONS = ["light", "dark", "system"] as const;
export type ModeVariant = (typeof THEME_MODE_OPTIONS)[number];

// KBP-21: storage keys MUST be tenant-scoped. Use scopedStorage + STORAGE_KEYS
// from @/lib/storage instead of building keys here. The old unscoped
// LOCAL_STORAGE_KEYS + VITE_STORAGE_PREFIX have been removed; legacy values
// stored under the old prefix are migrated on boot (see main.tsx →
// migrateLegacyStorageKeys).

export const WIZARD_FLOWS = {
  cart: {
    screens: ["cart", "identity", "pay", "success"] as const,
    steps: ["Carrito", "Identidad", "Pago", "Listo"] as const,
  },
  code: {
    screens: ["identity", "redeem", "success"] as const,
    steps: ["Identidad", "Activar", "Listo"] as const,
  },
} as const;

export type FlowId = keyof typeof WIZARD_FLOWS;
export type ScreenId = "cart" | "identity" | "pay" | "redeem" | "success";
